import { z } from 'zod';

/**
 * Hợp đồng DUY NHẤT cho `GET /api/provinces/boundaries` (Phase 4) — trả bare
 * FeatureCollection (không bọc `{success,data}`) với `properties.name ===
 * properties.maTinh` (khoá join ECharts của repo).
 *
 * Sống ở một module SCHEMA thuần (không import `apiClient`/`axios`), để cả
 * `services/provinceBoundaryApi.ts` lẫn `schemas/provinceConversion.ts` dùng
 * chung mà không kéo theo phụ thuộc dịch vụ nào — mock `provinceBoundaryApi`
 * (service) trong test không làm rớt các export này (M4: trước review có
 * HAI bản định nghĩa gần như y hệt ở hai module dịch vụ khác nhau, dựng lúc
 * Phase 5/6 chạy song song để tránh đụng file; gộp một schema RIÊNG thay vì
 * để module dịch vụ này phụ thuộc module dịch vụ kia).
 */
export const ProvinceBoundaryFeatureSchema = z.object({
	type: z.literal('Feature'),
	id: z.string(),
	properties: z.object({
		maTinh: z.string(),
		tenTinh: z.string(),
		name: z.string(),
	}).passthrough(),
	geometry: z.unknown(),
}).strip();
export type ProvinceBoundaryFeature = z.infer<typeof ProvinceBoundaryFeatureSchema>;

export const ProvinceBoundarySchema = z.object({
	type: z.literal('FeatureCollection'),
	features: z.array(ProvinceBoundaryFeatureSchema),
}).strip();
export type ProvinceBoundaryFeatureCollection = z.infer<typeof ProvinceBoundarySchema>;
